import {useEventBus} from "../../../assets-dev/ts/modules/use-event-bus";

export class ComponentPeopleList {
    private readonly itemClass = '.hd-people-list__item';
    private readonly itemActiveClass = 'active';
    private readonly itemContentClass = '.hd-people-list__item-content';
    private readonly itemCloseClass = '.hd-people-list__item__expanded-close';
    private readonly itemDescriptionClass = '.hd-people-list__item__expanded';
    private readonly noAnimationClass = 'no-animation';

    private el: HTMLElement;
    private items: HTMLElement[];
    private activeItemIndex: number | undefined;

    private itemToggleFns: any[] = [];
    private itemCloseFns: any[] = [];
    private onResizeFn;

    constructor(el: HTMLElement) {
        this.el = el;
        this.items = <HTMLElement[]>Array.from(el.querySelectorAll(this.itemClass));
        this.activeItemIndex = this.items.findIndex(item => item.classList.contains(this.itemActiveClass));
    }

    public onInit() {
        this.initToggles();
        this.initCloses();
        this.onResizeFn = this.onResize.bind(this);
        window.addEventListener('resize', this.onResizeFn);
        this.setActive();
    }

    public onDestroy() {
        window.removeEventListener('resize', this.onResizeFn);
        this.itemToggleFns.forEach((e) => {
            e.el.removeEventListener(e.event, e.fn);
        });
        this.itemToggleFns = [];
        this.itemCloseFns.forEach((e) => {
            e.el.removeEventListener(e.event, e.fn);
        });
        this.itemCloseFns = [];
    }

    private onResize() {
        this.setPaddingBottom();
    }

    private initToggles() {
        this.items.forEach((item, index) => {
            const el = item.querySelector(this.itemContentClass);
            if (el) {
                const e = {
                    el,
                    event: 'click',
                    fn: this.toggleIndex.bind(this, index),
                }
                this.itemToggleFns.push(e);
                e.el.addEventListener(e.event, e.fn);
            }
        });
    }

    private initCloses() {
        this.items.forEach(item => {
            const el = item.querySelector(this.itemCloseClass);
            if (el) {
                const e = {
                    el,
                    event: 'click',
                    fn: this.closeExpanded.bind(this),
                }
                this.itemCloseFns.push(e);
                e.el.addEventListener(e.event, e.fn);
            }
        });
    }

    private setPaddingBottom(oldHeight: number = 0) {
        if (this.activeItemIndex == null) {
            return;
        }
        const activeItem = this.items[this.activeItemIndex];
        if (!activeItem) {
            return;
        }
        const activeDescription = activeItem.querySelector(this.itemDescriptionClass);
        if (!activeDescription) {
            return;
        }
        if (oldHeight) {
            activeItem.classList.add(this.noAnimationClass);
            activeItem.style.paddingBottom = `${oldHeight}px`;
        }
        setTimeout(() => {
            activeItem.classList.remove(this.noAnimationClass);
            activeItem.classList.add('active');
            const height = activeDescription.getBoundingClientRect().height;
            activeItem.style.paddingBottom = `${height}px`;
        }, 0);
    }

    private toggleIndex(index) {
        this.activeItemIndex = this.activeItemIndex === index ? null : index;
        this.setActive();
    }

    private closeExpanded() {
        this.items.filter(item => item.classList.contains('active')).forEach(item => {
            item.classList.remove('active');
            item.style.paddingBottom = '0';
        });
    }

    private setActive() {
        let oldHeight: number = 0;
        this.items.filter(item => item.classList.contains(this.itemActiveClass)).forEach(item => {
            const oldDescription = item.querySelector(this.itemDescriptionClass);
            if (oldDescription) {
                oldHeight = oldDescription.getBoundingClientRect().height;
            }
        });
        this.closeExpanded();
        this.setPaddingBottom(oldHeight);
    }
}

export function useComponentPeopleList() {
    useEventBus('hd-people-list', ComponentPeopleList);
}